import type { Pedido } from './dominio';

// Relógio de cada pedido na lista do balcão: "há 12 min", "vence em 4 min", "atrasou 28 min". Conta do
// pedido feito (criadoEm) contra o prazo combinado da loja (empresas.prazo_minutos).

export const PRAZO_PADRAO_MIN = 40;
/** Espelho do check empresas_prazo_minutos (supabase/migrations/*_balcao_configuracoes.sql). */
export const PRAZO_MINIMO_MIN = 10;
export const PRAZO_MAXIMO_MIN = 240;
/** A partir disto antes do prazo, o relógio vira "vence em". */
export const AVISO_DO_PRAZO_MIN = 5;
/** O que o select de Configurações oferece. */
export const OPCOES_DE_PRAZO_MIN: readonly number[] = [20, 30, 40, 50, 60, 90, 120];

export type EstadoDoRelogio = 'ha' | 'vence' | 'atrasou';

export interface RelogioDoPedido {
  estado: EstadoDoRelogio;
  /** 'ha': minutos desde o pedido · 'vence': quanto falta · 'atrasou': quanto passou do prazo. */
  minutos: number;
}

export type TomDoRelogio = 'neutro' | 'alerta' | 'erro';

/** Prazo 40: 34 min → há 34 · 35 → vence em 5 · 40 → vence agora · 41 → atrasou 1. */
export function relogioDoPedido(
  p: Pick<Pedido, 'criadoEm'>,
  agora: Date,
  prazoMin: number,
): RelogioDoPedido {
  const decorrido = Math.max(0, Math.floor((agora.getTime() - Date.parse(p.criadoEm)) / 60_000));
  if (decorrido > prazoMin) return { estado: 'atrasou', minutos: decorrido - prazoMin };
  if (decorrido >= prazoMin - AVISO_DO_PRAZO_MIN) {
    return { estado: 'vence', minutos: prazoMin - decorrido };
  }
  return { estado: 'ha', minutos: decorrido };
}

/** "28 min" · "1h05" · "2 dias": o atraso de um pedido esquecido não vira "1440 min". */
export function duracaoCurta(minutos: number): string {
  if (minutos < 60) return `${minutos} min`;
  if (minutos < 24 * 60) {
    return `${Math.floor(minutos / 60)}h${String(minutos % 60).padStart(2, '0')}`;
  }
  const dias = Math.floor(minutos / (24 * 60));
  return dias === 1 ? '1 dia' : `${dias} dias`;
}

/** "agora" · "há 12 min" · "vence em 4 min" · "vence agora" · "atrasou 28 min". */
export function textoDoRelogio(r: RelogioDoPedido): string {
  if (r.estado === 'atrasou') return `atrasou ${duracaoCurta(r.minutos)}`;
  if (r.estado === 'vence') return r.minutos === 0 ? 'vence agora' : `vence em ${r.minutos} min`;
  return r.minutos === 0 ? 'agora' : `há ${duracaoCurta(r.minutos)}`;
}

export function tomDoRelogio(r: RelogioDoPedido): TomDoRelogio {
  if (r.estado === 'atrasou') return 'erro';
  return r.estado === 'vence' ? 'alerta' : 'neutro';
}
